import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/Images/pos.jpg";

export default function Navbar() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    // Get user from localStorage
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    } else {
      // Redirect to login if user is not logged in
      navigate("/");
    }
  }, [navigate]);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token"); // Token bhi remove karna na bhoolen
    navigate("/");
  };

  const goHomePage = () => {
    if (user?.role == "Admin") {
      navigate("/admin");
    } else if (user?.role == "Insurance") {
      navigate("/insuranceDashboard");
    } else if (user?.role == "Finance") {
      navigate("/financeDashboard");
    } else {
      navigate("/dashboard"); // Default dashboard
    }
  };

  // Function to get avatar content (first letter of name)
  const getAvatarContent = () => {
    if (user?.image) {
      return null; // Image hai to kuch mat dikhao, Avatar component khud image dikha dega
    }
    return user?.name ? user.name.charAt(0).toUpperCase() : "U";
  };

  return (
    <AppBar position="static" sx={{ bgcolor: "primary.main" }}>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        {/* Left side logo + name */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            cursor: "pointer",
          }}
          onClick={goHomePage}
        ></Box>

        {/* Right side user info */}
        {user && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body2" sx={{ textAlign: "right" }}>
              {user.name} <br />
              <span style={{ fontSize: "0.8em", opacity: 0.7 }}>
                {user.position || user.role}
              </span>
            </Typography>

            <Tooltip title={user.name}>
              <IconButton onClick={handleMenuOpen} sx={{ p: 0 }}>
                <Avatar
                  alt={user.name}
                  src={user.image || ""}
                  sx={{
                    bgcolor: user.image ? "transparent" : "secondary.main",
                    color: user.image ? "inherit" : "white",
                  }}
                >
                  {getAvatarContent()}
                </Avatar>
              </IconButton>
            </Tooltip>
          </Box>
        )}

        {/* Menu */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
